import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/images/right_l.png';

const _withScopeId = n => (_pushScopeId("data-v-79c1bb23"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "news-container"
};
const _hoisted_2 = {
  class: "category-list"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  key: 0,
  class: "big-news-list"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
const _hoisted_7 = ["title"];
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
  class: "small-news-list"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "news-date"
};
const _hoisted_12 = {
  class: "day"
};
const _hoisted_13 = {
  class: "year"
};
const _hoisted_14 = ["title"];
const _hoisted_15 = {
  key: 1,
  class: "empty-container"
};
const _hoisted_16 = {
  class: "more"
};
const _hoisted_17 = ["href"];

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1));

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_20 = [_hoisted_18, _hoisted_19];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CommonTitle = _resolveComponent("CommonTitle");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_CommonTitle, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($props.menu && $props.menu.module_name || '通知公告'), 1)]),
    _: 1
  }), _createElementVNode("div", _hoisted_2, [$data.classifyList.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.classifyList, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["category-item", $data.classifyId === item.id && 'active']),
      key: item.id,
      onClick: $event => $options.searchCourseList(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_3);
  }), 128)) : _createCommentVNode("", true)]), $data.bigNewsList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.bigNewsList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "big-news-item",
      key: index,
      onClick: $event => $options.handleLookDetail(item)
    }, [_createElementVNode("img", {
      class: "imgs",
      src: $data.mainRecommendNews ? $data.mainRecommendNews.news_cover_url : 'https://cus-prod-kcsz1.oss-cn-hangzhou.aliyuncs.com/shiepedu/4e5084fb84d442c592308723ad1a0277.jpg',
      alt: ""
    }, null, 8, _hoisted_6), _createElementVNode("div", {
      class: "title",
      title: item.news_name
    }, _toDisplayString(item.news_name), 9, _hoisted_7), _createElementVNode("div", {
      class: "new-intro",
      "data-html": "",
      innerHTML: _ctx.$utils.getContentText(item.context)
    }, null, 8, _hoisted_8)], 8, _hoisted_5);
  }), 128)), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.smallNewsList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "small-news-item",
      key: index,
      onClick: $event => $options.handleLookDetail(item)
    }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$utils.formatDate(item.publish_time, 'DD')), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$utils.formatDate(item.publish_time, 'YYYY.MM')), 1)]), _createElementVNode("div", {
      class: "title",
      title: item.news_name
    }, _toDisplayString(item.news_name), 9, _hoisted_14)], 8, _hoisted_10);
  }), 128))])])) : (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_Empty, {
    type: "message",
    text: "暂无数据"
  })])), _createElementVNode("div", _hoisted_16, [_createElementVNode("a", {
    href: `/notice.html?menuId=${$props.menu.menu_id}&name=${$props.menu.module_name}`
  }, _hoisted_20, 8, _hoisted_17)])]);
}